import {
  Box,
  FormControl,
  FormControlLabel,
  FormLabel,
  Radio,
  RadioGroup,
  TextField,
} from "@mui/material";
import { Controller, useFormContext } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { TypeSelect } from "../AtonSearchFormContainers/StateAndTypeForm";

export type SharedFormProps = {
  isDisabled?: boolean;
};

export type WaterTrafficSignStateFormTypes = {
  state: string;
  waterTrafficId: string;
};

export const waterTrafficSignStateFormDefaults: WaterTrafficSignStateFormTypes =
  { state: "", waterTrafficId: "" };

export const WaterTrafficSignStateForm = ({
  isDisabled = false,
}: SharedFormProps) => {
  const { t } = useTranslation("fairwayReport");
  const { register, control } =
    useFormContext<WaterTrafficSignStateFormTypes>();
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        gap: "10px",
      }}
    >
      <TextField
        disabled={isDisabled}
        {...register("waterTrafficId", { required: false })}
        label={t("fairwayReport:waterSignIdOrName")}
      />

      <FormControl
        disabled={isDisabled}
        sx={{ display: "flex", flexDirection: "column" }}
      >
        <FormLabel>{t("state")}</FormLabel>
        <Controller<WaterTrafficSignStateFormTypes>
          control={control}
          name="state"
          render={({ field }) => (
            <RadioGroup
              sx={{ display: "flex", flexDirection: "row" }}
              {...field}
            >
              <FormControlLabel
                value=""
                control={<Radio />}
                label={t("faultSearch:kaikki")}
              />
              <FormControlLabel
                value="confirmed"
                control={<Radio />}
                label={t("confirmed")}
              />
              <FormControlLabel
                value="removed"
                control={<Radio />}
                label={t("Removed")}
              />
              <FormControlLabel
                value="floating"
                control={<Radio />}
                label={t("Floating")}
              />
            </RadioGroup>
          )}
        />
      </FormControl>

      <TypeSelect isDisabled={isDisabled} />
    </Box>
  );
};
